import { render, staticRenderFns } from "./ed-copyrights.vue?vue&type=template&id=bda00ffe&scoped=true&"
import script from "./ed-copyrights.ts?vue&type=script&lang=ts&"
export * from "./ed-copyrights.ts?vue&type=script&lang=ts&"
import style0 from "./ed-copyrights.scss?vue&type=style&index=0&id=bda00ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda00ffe",
  null
  
)

export default component.exports